import api from ".";

export const me = async () => {
  const token = localStorage.getItem("uniservice_token");

  return api
    .get("/api/v1/me", {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    })
    .catch(() => {
      console.error("Ocorreu um erro ao buscar dados de usuário logado.");
    });
};
